import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    padding: 7em 0 0;
`;